export default __webpack_public_path__ + "static/media/GuyAnimation5.ab0412ce.svg";